import { theme } from 'antd';
import PropTypes from 'prop-types';
import { LAYOUT_HEADER_HEIGHT } from '@shared/constants/layout';

import './styles.css';

const ProgressBarLoading = ({ progressPercent = 0, infinite = false, fixedBelowHeader = false }) => {
  const { token: themeToken } = theme.useToken();
  const colorPrimary = themeToken.colorPrimary;

  const fixedStyle = fixedBelowHeader ? { position: 'fixed', top: LAYOUT_HEADER_HEIGHT, left: 0, zIndex: 20 } : {};

  if (infinite) {
    return (
      <div className='slider' style={fixedStyle}>
        <div className='line' style={{ backgroundColor: colorPrimary }} />
        <div className='subline inc' style={{ backgroundColor: colorPrimary }} />
        <div className='subline dec' style={{ backgroundColor: colorPrimary }} />
      </div>
    );
  }

  return (
    <div style={{ width: '100%', height: '10px', backgroundColor: '#d2d2d2', ...fixedStyle }}>
      <div style={{ width: `${progressPercent}%`, backgroundColor: colorPrimary, height: '100%' }} />
    </div>
  );
};

ProgressBarLoading.propTypes = {
  progressPercent: PropTypes.number,
  infinite: PropTypes.bool,
};

export default ProgressBarLoading;
